<template>
  <section class="comparative-previous-tournaments">
    <HeaderComponent title="Comparativo vs torneos anteriores" titlemovil="Comparativo vs torneos <br/> anteriores" />
    <div class="comparative-previous-tournaments__cont-bar-elements">
      <SwitchPercentOrNumberComparativePreviousTournaments @onChangeSwitch="onChangeSwitch" />
    </div>
    <div class="comparative-previous-tournaments__cont-table">
      <TableComparativePreviousTournaments :data="arrayComparison" :type="type" />
    </div>
    <ModalComparativePreviousTournaments :show="modal" @onCancel="onCancel" />
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ComparativePreviousTournaments',
  components: {
    HeaderComponent: () => import('@/components/ActiveTime/Elements/HeaderComponent'),
    TableComparativePreviousTournaments: () =>
      import('@/components/ActiveTime/Elements/TableComparativePreviousTournaments'),
    SwitchPercentOrNumberComparativePreviousTournaments: () =>
      import('@/components/ActiveTime/Elements/SwitchPercentOrNumberComparativePreviousTournaments'),
    ModalComparativePreviousTournaments: () =>
      import('@/components/ActiveTime/Modals/ModalComparativePreviousTournaments'),
  },
  props: {
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    seasons: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    seasons: {
      immediate: true,
      deep: true,
      handler: async function(newValue) {
        if (newValue && newValue.length) {
          const season = newValue.filter(season => season.type === 0)[0];
          await this.getComparison(season.id);
        }
      },
    },
  },
  computed: {},
  data() {
    return {
      type: 0,
      modal: false,
      url: 'https://6smb5j9iia.execute-api.us-east-2.amazonaws.com/prod/te/comparison/',
      arrayComparison: [],
    };
  },
  methods: {
    onChangeSwitch(val) {
      this.type = val;
    },
    openmodal() {
      this.modal = true;
    },
    onCancel() {
      this.modal = false;
    },
    async getComparison(season) {
      var s = 1;
      if (this.$route.query.s) {
        if (this.$route.query.s == 1 || this.$route.query.s == 0) {
          s = this.$route.query.s;
        }
      }
      const comparison = await axios
        .get(this.url + season + '?s=' + s)
        .then(response => response)
        .catch(e => {
          if (this.retries > 0) {
            this.retries = this.retries - 1;
            return this.getComparison(season);
          }
          return e;
        });
      if (comparison.data != '') {
        this.arrayComparison = [];
        for (let index = 0; index < comparison.data.length; index++) {
          var jsonSeason = {};
          var seasonSplit = comparison.data[index].season_name.split(' ');
          jsonSeason.season = comparison.data[index].season_name;
          jsonSeason.seasonShort = seasonSplit[0].charAt(0) + seasonSplit[1];
          comparison.data[index].comparison.forEach(item => {
            if (item.section_name == 'Saque de meta') {
              jsonSeason.metatime = item.time;
              jsonSeason.metaevent = item.events;
            }
            if (item.section_name == 'Saque de banda') {
              jsonSeason.bandatime = item.time;
              jsonSeason.bandaevent = item.events;
            }
            if (item.section_name == 'Tiro de esquina') {
              jsonSeason.esquinatime = item.time;
              jsonSeason.esquinaevent = item.events;
            }
            if (item.section_name == 'Faltas') {
              jsonSeason.faltatime = item.time;
              jsonSeason.faltaevent = item.events;
            }
          });
          this.arrayComparison.push(jsonSeason);
        }
      } else {
        this.arrayComparison = [];
      }
    },
  },
  created() {},
};
</script>
<style lang="scss">
.topf-container {
  .menu-top .switch input[type='checkbox'] + .check.is-success-passive,
  .menu-top .switch input[type='checkbox'] + .check:hover {
    background: #cbee6b !important;
  }
  .switch input[type='checkbox'] + .check.is-success-passive,
  .switch input[type='checkbox'] + .check:hover,
  .switch input[type='checkbox']:checked + .check:hover {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
  .switch.is-rounded input[type='checkbox'] + .check:before {
    background: #132839 !important;
    box-shadow: none !important;
  }
  .switch input[type='checkbox'] + .check {
    background: #cbee6b !important;
    box-shadow: none !important;
  }
}
</style>
<style lang="scss" scoped>
.comparative-previous-tournaments {
  &__cont-bar-elements {
    width: 100%;
    height: 28px;
    // background: purple;
    margin-top: 10px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 680px) {
      display: inline-block;
    }
  }
  &__cont-table {
    width: 100%;
    height: 231px;
    border-radius: 8px;
    border: solid 1px #132739;
    margin-top: 10px;
  }
}
</style>
